var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeroProductos'),(false)?_c('CarouselPropio'):_vm._e(),_c('Productos',{attrs:{"id":"seccion-productos"}}),_c('Promo'),_c('Redes'),_c('WhatsappFlotante')],1)}
var staticRenderFns = []

export { render, staticRenderFns }